import { Component } from '@angular/core';
import { Events, IonicPage, NavController, LoadingController, Loading, NavParams, AlertController, MenuController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { AuthServiceProvider} from '../../providers/auth-service/auth-service';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  public loading:Loading;
  usuarioi={
		idempresa: 1, usuario:'',clave:'', recordar_sn: false
	}
  pagina: string = "login";
  constructor(public events:Events, public navCtrl: NavController, public navParams: NavParams,
    public loadingCtrl: LoadingController, public authServices : AuthServiceProvider,
    public alertCtrl: AlertController, public menu : MenuController) {

    this.menu.enable(false);
       this.menu.swipeEnable(false);
  }

  ionViewDidLoad() {
  }

  ingresar(){
    this.loading = this.loadingCtrl.create({
          content: 'Iniciando sesión..',
          dismissOnPageChange: true,
        });
      this.loading.present();

    this.authServices.login(this.usuarioi).then(val => {
      if(val['restablecer']) this.cambiarpwd(val['id']);
      else this.cambiarPage();

    },(err) => {
        this.loading.dismiss();
        let alert = this.alertCtrl.create({
          title: "Acceso no permitido",
          subTitle: 'Las credenciales ingresadas son incorrectas',
          buttons: ['OK']
        });
        alert.present();
    });
  }

  cambiarPage(){
    //this.navCtrl.setRoot(HomePage);
    this.navCtrl.setRoot(HomePage).then(() => {
      this.events.publish('user:login');
      this.menu.enable(true);
       this.menu.swipeEnable(true);
          //setInterval(()=>{
            //window.location.reload();
            //},50)
        });
  }

  cambiarpwd(idusuario) {
    let prompt = this.alertCtrl.create({
      title: 'Bienvenido al portal web de Condominios Poseidon',
      message: "Digite su nueva contraseña",
      inputs: [
        {
          name: 'pwd',
          placeholder: 'Nueva contraseña'
        },
        {
          name: 'pwd2',
          placeholder: 'Repita su nueva contraseña'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
            this.cambiarPage();
          }
        },
        {
          text: 'Save',
          handler: data => {
            if(data["pwd"] == data["pwd2"]){
              var datos = { 'idempresa': this.usuarioi.idempresa, 'id': idusuario, 'clave': data["pwd"]};
              this.authServices.actualizarpwd(datos).then(val => {
                this.cambiarPage();
              },(err) => {});
            }
          }
        }
      ]
    });
    prompt.present();
  }

  cambiarSegmento(page){
    this.pagina = page;
  }

  forgotPWd(){
    if(this.usuarioi.usuario.length == 0){
        let alert = this.alertCtrl.create({
          title: 'Validacion de datos',
          subTitle: 'Realice los respectivos ingresos a realizar',
          buttons: ['OK']
        });
        alert.present();
    }
    else{
      var datos = { 'idempresa': this.usuarioi.idempresa, 'usuario': this.usuarioi.usuario };
      this.authServices.recuperar(datos).then(val => {
        this.usuarioi.clave = '';

        let alert = this.alertCtrl.create({
          title: "Contraseña restablecida",
          subTitle: 'Por favor, revise su correo electrónico',
          buttons: ['OK']
        });
        alert.present();

        this.cambiarSegmento('login');
      },(err) => {
        this.cambiarSegmento('login');
      });
    }

  }
  
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts